// src/utils/theme.ts
var isBaseTheme = (theme) => theme === "light" || theme === "dark";

export {
  isBaseTheme
};
